import React from 'react';
import { withTranslation } from '@i18n';
import {
  StyledDetailsCover,
  StyledMainHeadline,
  StyledTitleWrapper,
  StyledTitle,
  StyledDescription,
  StyledCardWrapper
} from './styles';

const TreatmentInfoCard = ({ t, data }) => (
  <StyledDetailsCover>
    <StyledMainHeadline>{t('TreatmentInfoCardTitle')}</StyledMainHeadline>
    {data.map(desc => (
      <StyledCardWrapper key={desc.id}>
        <StyledTitleWrapper>
          <StyledTitle>{desc?.attributes?.question}</StyledTitle>
        </StyledTitleWrapper>
        <StyledDescription>
          <div
              // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: desc?.attributes?.answer
            }}
          />
        </StyledDescription>
      </StyledCardWrapper>
    ))}
  </StyledDetailsCover>
);

export default withTranslation('ProfilePackages')(TreatmentInfoCard);
